import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastMessage = {
  success: (message) => {
    toast.success(message || "Success!", {
      position: "top-right",
      autoClose: 3000,
      theme: "colored",
    });
  },
  error: (message) => {
    toast.error(message || "Something went wrong!", {
      position: "top-right",
      autoClose: 3000,
      theme: "colored",
    });
  },
  info: (message) => {
    toast.info(message || "Here’s some info!", {
      position: "top-right",
      autoClose: 3000,
      theme: "colored",
    });
  },
  warning: (message) => {
    toast.warn(message || "Warning!", {
      position: "top-right",
      autoClose: 3000,
      theme: "colored",
    });
  },
};

export default ToastMessage;
